import { EntityFilter as EntityFilterType } from 'generated/resources/datatable.graphql'

import { ENTITY_FILTER_KINDS } from 'modules/core/components/DataTable/constants'
import type { Filter as FilterType } from 'modules/core/components/DataTable/types'
import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'
import Filter from 'modules/core/components/Filter'

import Header from './Header'

type Props<T> = {
  filter: FilterType<T>
  onValueChange: (value: unknown) => void
  onCategoryChange: (category: FilterType<T>['category']) => void
  defaultOpen?: boolean
}

export default function EntityFilter<T>({
  filter: dataTableFilter,
  onValueChange,
  onCategoryChange,
  defaultOpen,
}: Props<T>) {
  const { filter, category, value } = dataTableFilter

  const showHeader = filter.categories.length > 1
  const header = showHeader && (
    <Header filter={filter} category={category} onCategoryChange={onCategoryChange} />
  )

  const commonProps = {
    label: filter.title,
    onValueChange,
    header,
  }

  switch (category.kind) {
    case ENTITY_FILTER_KINDS.ENTITY:
      return (
        <Filter.EntitySelector
          {...commonProps}
          value={value}
          nameAttribute={category.nameAttribute}
          defaultOpen={defaultOpen}
          // eslint-disable-next-line no-type-assertion/no-type-assertion
          component={(category as EntityFilterType).component}
        />
      )
    case ENTITY_FILTER_KINDS.EMPLOYEE:
      return (
        <Filter.EmployeeSelector
          {...commonProps}
          // eslint-disable-next-line no-type-assertion/no-type-assertion
          value={(value as EmployeeForSelectFragmentNoAccess[]) ?? []}
          nameAttribute={category.nameAttribute || 'fullName'}
          defaultOpen={defaultOpen}
        />
      )
  }

  throw new Error(`Unknown filter kind: ${category.kind}`)
}
